<div class="level-items">

  <app-level-select-item
    *ngFor="let level of levelScores;" (clicked)="selectLevel(level)"
    [isSelected]="level.id === selectedLevelId" [level]="level" [score]="level?.selectedScore"
  ></app-level-select-item>

</div>

